import React from "react";
import { Button, Container, Header, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { dispatch } from "@rematch/core";

class CreateAccount extends React.Component {
  state = {

  };

  handleProceed = () => {
    this.props.history.push(
      `/newUser/${this.props.user.email}`
    );
  };

  handleSkip = async () => {
    await dispatch.login.setSkipAccountCreation(false);
    await dispatch.login.skipAccountCreationAsync({user:this.props.loggedInUserData, accountId:this.props.bookMarkedAccountId, isUnAuthorized:this.props.isUnAuthorized, fromUrl:this.props.fromUrl});
  };

  render() {
    return (
      <div className="backgroundCss">
        { this.props.loggedInUserData && !this.props.loggedInUserData.user.accounts.some(account => account.role === 'customerAdmin') &&
          <Container className="bg-white" style={{ padding: "20px", width: "25%" }}>
            <Header>
              <div style={{ marginTop: '15px', fontSize: "24px", textAlign: "center" }}>
                <Icon name="user plus" />
                Create Account
              </div>
            </Header>
            <div
              style={{ marginTop: "15px", fontSize: "12px", textAlign: "center" }}
            >
              <b>It seems you don't have an account yet</b>
              <p><b>Would you like to create your own account now and join our community?</b></p>
            </div>
            <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop:"15px" }}>
            <Button negative onClick={this.handleSkip}>
            <Icon name="ban" /> Skip
          </Button>
          <Button positive onClick={this.handleProceed}>
            <Icon name="check" /> Proceed
          </Button></div>
          </Container>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.app.user,
    accessToken: state.login.accessToken,
    bookMarkedAccountId: state.login.bookMarkedAccountId,
    fromUrl:state.login.fromUrl,
    loggedInUserData: state.login.loggedInUserData,
    isUnAuthorized: state.login.isUnAuthorized,
  };
}

const connectedCreateAccountPage = connect(mapStateToProps)(CreateAccount);
export { connectedCreateAccountPage as CreateAccount };
